module.exports = __webpack_public_path__ + "img/main-gallery4.886a3340.webp";